import React, { Component, Suspense } from 'react';
import Slider from 'react-slick';

import './App.css';
//Import components
import ProgresBar from './components/ProgresBar';
import Brand from './components/Brand';
import Bulp from './components/Bulp';
import Note from './components/Note';
import Products from "./components/Products";
import Vehicle from "./components/Vehicle";
import BuyModal from "./components/BuyModal";
import ShareModal from "./components/ShareModal";
import Disclaimer from "./components/Disclaimer"
//Library for cookies
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import queryString from 'query-string'

import { apiService } from './service/Apiservice';

//import { FormattedMessage } from 'react-intl';
import { withTranslation } from "react-i18next";

//import { Button } from 'reactstrap';

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };
  
  constructor(props) {
    super(props);
    const { cookies } = props
    const lang = cookies.get('cvlrglang') ? cookies.get('cvlrglang').toLowerCase() : '';
    let useCookies = !(!cookies.get('cvlrgvehicle') && !cookies.get('cvlrgvehiclekba'))

    this.handleShowBuy = this.handleShowBuy.bind(this);
    this.handleHideBuy = this.handleHideBuy.bind(this);
    
    const values = queryString.parse(window.location.search)
    var dropdowns = null
    if (values.brand && values.model && values.year && values.type) {
      dropdowns = `${values.brand}|${values.model}|${values.year}|${values.type}`
    }

    this.state = {
      isCompleteBrand: false, //Are finish selection of brand
      isCompleteBulp: false, //Are finish selection of bulp
      isCompleteNote: false, //Are finish selection of Note
      isCompleteProduct: false, //Are finish selection of Product
      forceBrandExpand: true,
      forceBulpExpand: true,
      forceNoteExpand: true,
      lang: lang,
      selectedPicture: '', // If you have stored picture then will show on right side of screen
      show: false, // Are you show Modal for buy or not
      showBuyCookie: false,
      showSelection: false,
      hideVehicle: true,
      key: 1,
      useCookies: useCookies,
      forceCookieCreation: false,
      forceCookieRemoval: false,
      selectedNote: '',
      selectedProduct: '',
      carID: values.car ? values.car : '',
      selectedBulb: '',
      bulps: [],
      technologies: [],
      productList: '',
      zmp: '',
      thumb_img: '',
      main_img: '',
      zmp_text: '',
      selected_image: null,
      searchKBA: '',
      ECE:'',
      tehnicalData:'',
      oonum:'',
      productLine:'',
      vehicleKind: values.kind ? parseInt(values.kind, 10) : null,
      benefits: null,
      ledInfoText: '',
      offRoadInfoText: '',
      buyURL: null,
      nav1: null,
      nav2: null,
      partFromURL: values.part,
      kbaFromURL: values.kba,
      dropdownsFromURL: dropdowns,
      zmpFromURL: values.zmp,
      technologyFromURL: values.technology,
      bulbFromURL: values.bulb
    }
  }
  
  resetFromURLBrand = () => {
    this.setState({
      partFromURL: null,
      kbaFromURL: null,
      dropdownsFromURL: null
    })
  }

  resetFromURLBulb = () => {
    this.setState({
      bulbFromURL: null
    })
  }

  resetFromURLTechnology = () => {
    this.setState({
      technologyFromURL: null
    })
  }

  resetFromURLProduct = () => {
    this.setState({
      zmpFromURL: null
    })
  }
  ////////////PANEL STATUS FINISH OR NOT

  // Is it complete Brand or not, passing callback function to ProgresBar.
  completeFormBrand = (carID, dropdowns, part, kba) => {
    this.setState({
      isCompleteBrand: true,
      carID: carID,
      dropdowns: dropdowns,
      part: part,
      kba: kba,
    })
  }
  nocompleteFormBrand = () => {
    this.setState({
      isCompleteBrand: false
    })
  }
  shouldForceExpandBrand = () => {
    let isForced = this.state.forceBrandExpand
    if (isForced) {
      this.setState({ forceBrandExpand: false })
    }
    
    return isForced
  }

  onSearchByPartSuccess = (productsList) => {
    this.setState({
      productsList: productsList,
      isCompleteBrand: true,
      isCompleteBulp: true,
      bulps: [],
      isCompleteNote: true,
      technologies: [],
      selectedPicture: false,
      carID: '',
    })
  }

  //Brand End

  // Is it complete Brand or not, passing callback function to ProgresBar.
  completeFormBulp = () => {
    this.setState({
      isCompleteBulp: true
    })
  }
  shouldForceExpandBulp = () => {
    let isForced = this.state.forceBulpExpand
    if (isForced) { this.setState({ forceBulpExpand: false })}
  
    return isForced
  }
  // Bulp End


  // Is it complete Note or not, passing callback function to ProgresBar.
  completeFormNote = () => {
    this.setState({
      isCompleteNote: true
    })
  }
  shouldForceExpandNote = () => {
    let isForced = this.state.forceNoteExpand
    if (isForced) {this.setState({ forceNoteExpand: false }) }
    return isForced
  }
  // Note End

  // Is it complete Product or not.
  completeFormProduct = (pic) => {
    this.setState({
      isCompleteProduct: true,
      selectedPicture: pic || 'osram'

    })
  }
  // Product End


  ////////////PANEL ENDS

  ////////////COOKIE
  toggleCookieUsage = () => {
    let currentState = this.state.useCookies
    this.setState({
      useCookies: !currentState,
      forceCookieCreation: !currentState,
      forceCookieRemoval: currentState,
    })
  }

  resetForceFlags = () => {
    this.setState({
      forceCookieCreation: false,
      forceCookieRemoval: false,
    })
  }
  ////////////COOKIE END

  ////////////MODAL

  //MODAL BUY
  handleShowBuy = () => {
    this.setState({ show: false });

  }

  handleHideBuy = () => {
    this.setState({ show: false });
  }

  ////////////MODAL END


  //MODAL BUY BY COOKIE
  handleShowBuyCookie = () => {
    this.setState({ showBuyCookie: true });

  }

  handleHideBuyCookie = () => {
    this.setState({ showBuyCookie: false });
  }

  ////////////MODAL BUY BY COOKIE


  ////////////STEPS JUMP

  selectDotOne = (forceBrandExpand, showVehiclePicker) => {
    if (!this.state.isCompleteBrand && !showVehiclePicker) return;
    let kind = this.state.vehicleKind
    if (showVehiclePicker) {
      kind = null
    }
    this.setState({
      isCompleteBrand: false,
      forceBrandExpand: forceBrandExpand || false,
      isCompleteBulp: false,
      forceBulpExpand: true,
      selectedBulb: '',
      bulps: [],
      isCompleteNote: false,
      forceNoteExpand: true,
      selectedNote: '',
      technologies: [],
      selectedPicture: false,
      productsList: [],
      benefits: null,
      vehicleKind: kind,
      selected_image: null,
      buyURL: null,
    })
  }

  selectDotTwo = (forceBulpExpand) => {
    if (!this.state.isCompleteBulp || !this.state.bulps || this.state.bulps.length === 0) return;
    this.setState({
      isCompleteBrand: true,
      isCompleteBulp: false,
      forceBulpExpand: forceBulpExpand || false,
      selectedBulb: forceBulpExpand ? '' : this.state.selectedBulb,
      isCompleteNote: false,
      forceNoteExpand: true,
      selectedNote: '',
      technologies: [],
      selectedPicture: false,
      benefits: null,
      selected_image: null,
      buyURL: null,
    })
  }

  selectDotThree = (forceNoteExpand) => {
    if (!this.state.isCompleteNote || !this.state.technologies || this.state.technologies.length === 0) return;
    this.setState({
      isCompleteBrand: true,
      isCompleteBulp: true,
      isCompleteNote: false,
      forceNoteExpand: forceNoteExpand || false,
      selectedNote: forceNoteExpand ? '' : this.state.selectedNote,
      selectedPicture: false,
      benefits: null,
      selected_image: null,
      buyURL: null,
    })
  }

  selectDotFour = () => {
    if (!this.state.isCompleteProduct) return;
    this.setState({
      isCompleteBrand: true,
      isCompleteBulp: true,
      isCompleteNote: true,
      selectedPicture: false,
      benefits: null,
    })
  }

  jumpTwo = (x) => {
    this.setState({
      selectedBulb: x,

    })
  }
  jumpThree = (x) => {
    this.setState({
      selectedNote: x
    })
  }
  jumpFour = (x) => {
    this.setState({
      selectedProduct: x
    })
  }
  ////////////STEPS JUMP END ///////////

  collectBulbs = (bulpList) => {
    this.setState({
      bulps: bulpList,

    })
  }

  collectTechnologies = (seleted) => {
    this.setState({
      technologies: seleted
    })

    if (typeof this.state.technologies === 'undefined') {
      this.setState({
        iscompleteNote: false
      })
    }
  }

  getProductsList = (products) => {
    this.setState({
      productsList: products
    })
  }

  getProductZmp = (zmp) => {
    this.setState({
      zmp: zmp,
    })

    apiService.fetchDescription(this.getLang(), zmp)
      .then(resZmp => {
        this.setState({
          thumb_img: resZmp.thumb_img,
          main_img: resZmp.main_img,
          zmp_text: resZmp.marketing_text,
          selected_image: resZmp.main_img && resZmp.main_img.length > 0 ? resZmp.main_img[0] : null,
          ECE:resZmp.oece,
          tehnicalData:resZmp.linfo,
          oonum:resZmp.oonum,
          benefits: resZmp.benefits,
          ledInfoText: resZmp.ledinfotext,
          offRoadInfoText: resZmp.offroadinfotext,
          buyURL: resZmp.buy_now_links && resZmp.buy_now_links.length > 0 ? resZmp.buy_now_links[0] : 'http://www.google.com', //null, 
        })
        
      })
      
  }

  componentDidMount() {
    //On start we checking is cookie checked, if is checked we showing start modal with your previous selected car.
    if (this.state.useCookies) {
      // this.handleShowBuyCookie()
    }

    // For slick slider
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    })
  }

  // TODO (translation) consider how to drop this
  getLang = () => {
    return this.state.lang ? this.state.lang : '';
  }

  setKind = (kind) => {
    this.setState({ vehicleKind: kind })
  }

  renderBenefit = (benefit) => {
    if (!benefit) {
      return null
    }
    let encodedQueryPart = encodeURIComponent(`${ benefit.iconText } - ${ benefit.featureText }`)
    let iconURL = `https://media.osram.info/media/resource/32x32/${benefit.icon}/${encodedQueryPart}.jpg`
    let standardRow1 = []
    let standardRow2 = []
    let featureRow1 = []
    let featureRow2 = []
    let featureRow3 = []
    for (let i = benefit.standardValue; i > 0; i--) {
      standardRow1.push(<td></td>)
      standardRow2.push(<td className="donotshow"></td>)
    }
    for (let i = benefit.featureValue; i > 0; i--) {
      featureRow1.push(<td></td>)
      if (i === benefit.feature_value) {
        featureRow2.push(<td></td>)
      } else {
        featureRow2.push(<td className="donotshow"></td>)
      }
      featureRow3.push(<td className="donotshow"></td>)
    }
    return(
      <tr>
      <tr className="benefit-line">
        <td className="benefit-icon" rowSpan="4"><img src={ iconURL } alt="benefit_icon" /></td>
        <td className="benefit-icontext" rowSpan="4">{ benefit.iconText }</td>
          <td className="benefit-featuretext" colSpan="12">{benefit.featureText ? benefit.featureText : <span>&nbsp;</span>}</td>
      </tr>
      <tr className="benefit-featurevalue">
          {featureRow1}
          {featureRow2}
          {featureRow3}
      </tr>
        <tr className="benefit-standardvalue">
          {standardRow1}
          {standardRow2}
          {standardRow2}
      </tr>
        <tr><td className="benefit-standardtext" colSpan="12">{benefit.standardText ? benefit.standardText : <span>&nbsp;</span> }</td></tr>
     </tr>
    )
  }

  renderSlide = (slides) => {
    let [...images] = slides;

    let imageSlide = images.map((image, i) => {
      return (<div key={i}><img src={image} alt="" /></div>)
    })

    return imageSlide;
  }

  render() {
    let zmpValue  =this.state.zmp
    let productLine = this.state.productsList
    let productTitle = ''
    if (zmpValue && productLine){
      productLine.filter(product => product.zmp === zmpValue).map(product => productTitle = product.use_name)
    }
    
    let mainImage = this.state.main_img;
    let thumbImage = this.state.thumb_img;
    const { t } = this.props;
    
    //console.log('thumb image',this.state.main_img);
    
    return (
      <Suspense fallback="loading">
      <div className="container">
        <div className="App row">
          <header className="App-header">
            <h1 className="App-title">{t("app.title")}</h1>
          </header>
          <div className="App-intro">
            <ProgresBar getLang={this.getLang} isCompleteBrand={this.state.isCompleteBrand} isCompleteBulp={this.state.isCompleteBulp} isCompleteNote={this.state.isCompleteNote} isCompleteProduct={this.state.isCompleteProduct}
              selectDotOne={this.selectDotOne} selectDotTwo={this.selectDotTwo} selectDotThree={this.selectDotThree} selectDotFour={this.selectDotFour} useCookies={this.state.useCookies} selectedBulb={this.state.selectedBulb}
              selectedNote={this.state.selectedNote} selectedProduct={this.state.selectedProduct} />
          </div>
          {!this.state.vehicleKind ? <Vehicle getLang={this.getLang} setKind={this.setKind} /> : null}
          <div className={(this.state.vehicleKind) ? 'display-block' : 'none'}>
          <div className="col-md-6">
            <div className="col-md-12">
                {this.state.vehicleKind ? <Brand kind={this.state.vehicleKind} getLang={this.getLang} resetFromURL={this.resetFromURLBrand} completeFormBrand={this.completeFormBrand} nocompleteFormBrand={this.nocompleteFormBrand} shouldForceExpand={this.shouldForceExpandBrand} useCookies={this.state.useCookies} resetForceFlags={this.resetForceFlags} forceCookieCreation={this.state.forceCookieCreation} forceCookieRemoval={this.state.forceCookieRemoval} selectDotOne={this.selectDotOne} collectBulbs={this.collectBulbs} carID={this.state.carID} onSearchByPartSuccess={this.onSearchByPartSuccess} partNumber={this.state.partFromURL} kbaNumber={this.state.kbaFromURL} dropdowns={this.state.dropdownsFromURL}  /> : null }
            </div>
            <div className={(this.state.isCompleteBrand && this.state.bulps.length === 0) ? 'col-md-12 display' : 'none'}>
              <p>{t("product.notFound")}</p>
            </div>
            <div className={(this.state.isCompleteBrand && this.state.bulps && this.state.bulps.length > 0) ? 'col-md-12 display' : 'none'}  >
                <Bulp getLang={this.getLang} resetFromURL={this.resetFromURLBulb} completeFormBulp={this.completeFormBulp} shouldForceExpand={this.shouldForceExpandBulp} useCookies={this.state.useCookies} openBrand={this.state.openBrand} jumpTwo={this.jumpTwo} selectDotTwo={this.selectDotTwo} bulps={this.state.bulps} carID={this.state.carID} collectTechnologies={this.collectTechnologies} isCompleteBulp={this.state.isCompleteBulp} bulp={this.state.bulbFromURL} />
            </div>
              {this.state.isCompleteBulp && this.state.technologies && this.state.technologies.length > 0 ? 
                <div className="col-md-12 display" >
                  <Note getLang={this.getLang} resetFromURL={this.resetFromURLTechnology} completeFormNote={this.completeFormNote} selectedNote={this.state.selectedNote} shouldForceExpand={this.shouldForceExpandNote} useCookies={this.state.useCookies} jumpThree={this.jumpThree} selectDotThree={this.selectDotThree} carID={this.state.carID} selectedBulb={this.state.selectedBulb} technologies={this.state.technologies} getProductsList={this.getProductsList} getProductLineName={this.getProductLineName} isCompleteNote={this.state.isCompleteNote} noteFromURL={this.state.technologyFromURL} />
            </div>
            : null }
            {this.state.isCompleteNote ? 
            <div className="col-md-12 display" >
                  <Products getLang={this.getLang} resetFromURL={this.resetFromURLProduct} completeFormProduct={this.completeFormProduct} toggleCookieUsage={this.toggleCookieUsage} showCookiesSection={!(!this.state.carID)} useCookies={this.state.useCookies} jumpFour={this.jumpFour} selectDotFour={this.selectDotFour} productsList={this.state.productsList} getProductZmp={this.getProductZmp} getProductLineName={this.getProductLineName} zmpFromURL={this.state.zmpFromURL} />
            </div>
            : null}
          </div>
          <div className={(!!this.state.selectedPicture === true) ? "none" : "col-md-6"} >
            <div className="right-col-info">
                <h4>{t("app.replacementBulbTitle")}</h4>
                <p>{t("app.replacementBulbDescription")}</p>
            </div>
          </div>

          {/* If we have selected picture-product show picture */}
            <div id="vlrg-product-info" className={(!!this.state.selectedPicture === true) ? "col-md-6 display right-col" : "none"}>
              <div className="right-col-content">
                <h3>{t("app.osram")} {productTitle} {this.state.ECE}</h3>
                <div className="action-links">
                  <ShareModal getLang={this.getLang}  bulp={this.state.selectedBulb} technology={this.state.selectedNote} partNumber={this.state.part} kbaNumber={this.state.kba} dropdowns={this.state.dropdowns} carID={this.state.carID} kind={this.state.vehicleKind} zmp={this.state.zmp} ordernr={this.state.oonum} />
                </div>
                <div className="main-slider-wrapper">
                  <Slider
                    asNavFor={this.state.nav2}
                    ref={slider => (this.slider1 = slider)}
                    arrows={false}
                    variableWidth={true}
                    initialSlide={0}
                    infinite={false}
                    fade={true}
                    className="product-image"
                  >
                    {this.renderSlide(mainImage)}
                  </Slider>
                </div>
                <div className="slick-carousel vlrg-product-gallery">
                  <Slider
                    asNavFor={this.state.nav1}
                    ref={slider => (this.slider2 = slider)}
                    slidesToShow={1}
                    slidesToScroll={1}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    infinite={false}
                    initialSlide={0}
                    variableWidth={true}
                    className="ms-product-img-carousel slick-slider">
                    {this.renderSlide(thumbImage)}
                  </Slider>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="prod-r-details">
                      <h4>{t("product.detailsTitle")}</h4>
                      <table className="table">
                        <tbody>
                          <tr>
                            <th scope="row">{t("app.productLine")}</th>
                            <td>{productTitle} {this.state.ECE}</td>
                          </tr>
                          <tr>
                            <th scope="col">{t("app.orderNumber")}</th>
                            <td>{this.state.oonum}</td>
                          </tr>
                          <tr>
                            <th scope="col">{t("app.eceCategory")}</th>
                            <td>{this.state.ECE}</td>
                          </tr>
                          <tr>
                            <th scope="col">{t("app.technicalData")}</th>
                            <td>{this.state.tehnicalData}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="prod-r-feat">
                      {
                        (this.state.offRoadInfoText) ?
                            <div>
                              {renderHTML(this.state.offRoadInfoText)}
                            </div>
                            : null
                      }
                      {(this.state.ledInfoText) ? (
                          <div>
                            <h4>{t("product.productfeatureslabel")}</h4>
                            {renderHTML(this.state.ledInfoText)}
                          </div>
                      ) : this.state.benefits && this.state.benefits.length > 0 ? (
                          <div>
                            <h4>{t("product.productfeatureslabel")}</h4>
                            <table className="benefit-outer">
                              {
                                this.state.benefits.map((benefit) => this.renderBenefit(benefit))
                              }
                            </table>
                          </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

      </div>
        <Disclaimer getLang={this.getLang} />
        <BuyModal showModal={this.state.show} onHide={this.handleHideBuy} externalURL={this.state.buyURL} />
        
      </div>
      </Suspense>
    );
  }
}

//export default withCookies(App);
const cookieWrap = withCookies(App);
const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
export default withTranslation()(cookieWrap);
